import React from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const walletSchema=Yup.object().shape({
  
})
export function WalletInfo() {
  const [fileNames, setFileNames] = useState("Browse");
  const [imagePreviews, setImagePreviews] = useState([]);

  function handleFileChange(event) {
    const files = event.target.files;
    if (files.length > 5) {
      alert("You can only select up to 5 images!");
      event.target.value = "";
      setFileNames("Browse");
      setImagePreviews([]);
      return;
    }
    // Convert FileList to Array
    const fileArray = Array.from(files);

    // Show file names
    setFileNames(fileArray.map((file) => file.name).join(", "));

    // Generate image previews
    const previews = fileArray.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  }
  const formik =useFormik({
    initialValues:{

    }
  })
  return (
    <div>
      {/* row1 */}
      <div className="wallet-subcontainer">
        <div>
          <div className="wallet-label">Wallet Balance</div>
          <div className="wallet-input">
            <input type="number" />
          </div>
        </div>
      </div>
      {/* row2 */}
      <div className="wallet-subcontainer">
        <div>
          <div className="wallet-label">User Image</div>
          <div className="wallet-input">
            <label for="fileInput" class="custom-file-label">
              {fileNames}
            </label>

            <input
              type="file"
              id="fileInput"
              class="custom-file-input"
              accept="image/*"
              multiple
              onChange={handleFileChange}
            />
            <div className="wallet-label">Can add upto 5 images</div>
            <div className="image-preview-container">
              {imagePreviews.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Preview ${index}`}
                  className="image-preview"
                />
              ))}
            </div>
          </div>
        </div>
        <div>
          <div>&nbsp;</div>
          <input type="checkbox"></input>
          <label className="wallet-label">Is Profile</label>
        </div>
      </div>
    </div>
  );
}
